import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { usePermissionInfo } from './useAccessControl'
import { updateNavigationAccessControl } from 'app/store/actions/fuse/navigation.actions.js'

const AccessControlMenu = ({ children }) => {
  const dispatch = useDispatch()
  const permissionInfo = usePermissionInfo()

  useEffect(() => {
    dispatch(updateNavigationAccessControl(permissionInfo))
  }, [permissionInfo, dispatch])

  return children
}

export default AccessControlMenu
